
import Vue from 'vue'
import { mapState } from 'vuex'

export default Vue.extend({
  data: () => ({
    drawer: true,
    selectedMenu: 'InvoicesList',
    items: [
      {
        icon: 'mdi-receipt-text-outline',
        text: 'Facturas',
        link: { name: 'InvoicesList' }
      }
    ],
    isTest: false
  }),
  computed: {
    ...mapState(['user'])
  },
  created () {
    if (this.user.type === 'admin') {
      this.items.push(
        {
          icon: 'mdi-hospital-building',
          text: 'Proyectos',
          link: { name: 'ProjectsList' }
        },
        {
          icon: 'mdi-account-group',
          text: 'Usuarios',
          link: { name: 'UsersList' }
        },
        {
          icon: 'mdi-currency-usd',
          text: 'Retenciones',
          link: { name: 'RetentionsList' }
        }
      )
    }
    this.selectedMenu = this.$route.name
  },
  methods: {
    logout () {
      this.$store.dispatch('logout')
      this.$router.replace('/login')
    },
    goTo (link: string) {
      this.$router.push(link)
    }
  }
})
